import { useMutation, useQuery } from '@tanstack/react-query';
import { SMSChatBox } from './SMSChatBox';
import { createSMSSession, getSMSSession } from '../common/api/contacts';
import { Button, Container, Header, Spinner } from '@cloudscape-design/components';
import { formatPhoneNumber } from '../common/formatting/phoneFormat';

export type SMSChatViewProps = {
  uuid: string;
};

export function ContactSMSChatView(props: SMSChatViewProps) {
  const { uuid } = props;

  const createReq = useMutation({
    mutationFn: createSMSSession,
  });

  const sessionReq = useQuery({
    queryKey: ['contacts', uuid, 'sms'],
    queryFn: () => getSMSSession(uuid),
    retry(failureCount, error) {
      if (error instanceof Error && error.message.includes('404')) {
        // 404 means the session doesn't exist, so we don't need to retry
        return false;
      }
      return true;
    },
  });

  const loading = createReq.isPending || sessionReq.isPending;

  const session = sessionReq.data ?? createReq.data;

  return (
    // TODO tune height better
    <Container
      header={
        <Header variant="h2">
          SMS Chat with{' '}
          {session?.place_contact?.phone_number
            ? formatPhoneNumber(session?.place_contact?.phone_number)
            : ''}
        </Header>
      }
    >
      {session ? (
        <SMSChatBox session={session} />
      ) : loading ? (
        <div className="flex justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <div className="flex justify-center items-center">
          <Button onClick={() => createReq.mutate(uuid)} disabled={createReq.isPending}>
            Create Session
          </Button>
        </div>
      )}
    </Container>
  );
}
